import { connect } from 'react-redux'

import { showModal } from 'redux/modules/modals'
import LockersComponent from '../components/LockersComponent'

const mapActionCreators = {
  showModal
}

const mapStateToProps = state => {
  return {
    lockers: state.lockers.list
  }
}

export default connect(mapStateToProps, mapActionCreators)(LockersComponent)



// WEBPACK FOOTER //
// ./src/routes/Admin/Lockers/containers/AdminLockersContainer.js